export default "__VITE_PUBLIC_ASSET__af5be56d__"